import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "x",
  "use": "x-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"x\">\n<path d=\"M1.7,24c-0.5,0-0.9-0.2-1.2-0.5c-0.7-0.7-0.7-1.7,0-2.4L21.1,0.5c0.7-0.7,1.7-0.7,2.4,0c0.7,0.7,0.7,1.7,0,2.4L2.9,23.5\n\tC2.6,23.8,2.2,24,1.7,24z\" />\n<path d=\"M22.3,24c-0.5,0-0.9-0.2-1.2-0.5L0.5,2.9c-0.7-0.7-0.7-1.7,0-2.4s1.7-0.7,2.4,0l20.6,20.6c0.7,0.7,0.7,1.7,0,2.4\n\tC23.1,23.8,22.8,24,22.3,24z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol